// FocusRestoreContext.js
import React, { createContext, useContext, useEffect, useRef } from "react";

const FocusRestoreContext = createContext(null);

export const FocusRestoreProvider = ({ children }) => {
    const lastFocusedNameRef = useRef(null);
    const shouldRestoreRef = useRef(false);

    const registerFocus = (name) => ({
        onFocus: () => {
            lastFocusedNameRef.current = name;
            shouldRestoreRef.current = true;
        },
    });

    useEffect(() => {
        if (!shouldRestoreRef.current || !lastFocusedNameRef.current) return;

        requestAnimationFrame(() => {
            const el = document.querySelector(
                `[name="${lastFocusedNameRef.current}"]`
            );

            if (el && document.activeElement !== el) {
                el.focus();
            }

            shouldRestoreRef.current = false;
        });
    });


    return (
        <FocusRestoreContext.Provider value={{ registerFocus }}>
            {children}
        </FocusRestoreContext.Provider>
    );
};

export const useFocusRestore = () => {
    const ctx = useContext(FocusRestoreContext);
    if (!ctx) {
        throw new Error("useFocusRestore must be used inside FocusRestoreProvider");
    }
    return ctx;
};
